import VerificationIcon from "@components/common/icons/verification.icon";
import { Box, Typography } from "@mui/material";

function PostConfirmation() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "2rem",
        maxWidth: 600,
        margin: "4rem auto 0",
        textAlign: "center",
        "& svg *": {
          fill: "#fff",
        },
      }}
    >
      <Typography variant="h4" sx={{ fontWeight: 400 }}>
        Félicitation!
      </Typography>

      <VerificationIcon />

      <Typography>
        Vous venez de valider votre livraison. ALB vous remercie de votre confiance. Nous mettons
        mettre tout en oeuvre afin de vous offrir le meilleur service.
      </Typography>

      <Typography>
        Vous recevrez par email et SMS une explication des démarches de sécurité à effectuer le jour
        de prise en main de votre véhicule.
      </Typography>

      <Typography>Merci et à bientôt.</Typography>
    </Box>
  );
}

export default PostConfirmation;
